module.exports = __webpack_public_path__ + "img/google.badb7f26.svg";